import React, { useState } from 'react';

import { Control } from '@vlabs/uikit';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import st from './SharedCell.module.sass';
import { useNotificationRenders } from './useNotificationRenderers';

export function NotificationOption({ value = {} }) {
  const { t } = useTranslation();
  const [showAll, setShowAll] = useState(false);

  const [eventRenders, vaRenders] = useNotificationRenders();
  const VISIBLE_LIMIT = 3;

  const allEventTags = Object.entries(value.type ? vaRenders : eventRenders)
    .map(([key, render]) => {
      const element = render(value);
      return element ? <React.Fragment key={key}>{element}</React.Fragment> : null;
    })
    .filter(Boolean);

  const visibleTags = showAll ? allEventTags : allEventTags.slice(0, VISIBLE_LIMIT);
  const shouldShowButton = allEventTags.length > VISIBLE_LIMIT;

  return (
    <div className={st.CreationRulesCell}>
      {visibleTags}
      {shouldShowButton && !showAll && (
        <Control.Link
          as="button"
          kind="secondary"
          onClick={() => setShowAll(true)}
          size="medium"
          title={t('vlNotifier:show all rules')}
        >
          {t('кнопка.показать ещё')}
        </Control.Link>
      )}
    </div>
  );
}

NotificationOption.propTypes = {
  value: PropTypes.object,
};
